import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const tabBar = tv({
  slots: {
    container: 'relative flex flex-row items-end overflow-x-auto',
    underline: 'absolute bottom-0 block h-0.5 bg-brand-dark web:transition-all web:duration-300',
  },
})

export const tabBarItem = tv({
  slots: {
    button:
      'flex-1 border-b border-solid border-ui-grey p-4 text-center hover:opacity-70 active:opacity-70 web:transition web:duration-300',
    text: caption({ color: 'uiGreyDark', align: 'center' }),
  },
  variants: {
    isSelected: {
      true: {
        text: 'text-brand-dark',
      },
    },
  },
})
